var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsageSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8182 7.5C20.2364 7.5 19.3527 9.06 19.7127 10.2192L15.84 14.0758C15.5127 13.9783 15.0327 13.9783 14.7055 14.0758L11.9236 11.3133C12.2945 10.1542 11.4109 8.58333 9.81818 8.58333C8.23636 8.58333 7.34182 10.1433 7.71273 11.3133L2.73818 16.2425C1.57091 15.885 0 16.7625 0 18.3333C0 19.525 0.981818 20.5 2.18182 20.5C3.76364 20.5 4.64727 18.94 4.28727 17.7808L9.25091 12.8408C9.57818 12.9383 10.0582 12.9383 10.3855 12.8408L13.1673 15.6033C12.7964 16.7625 13.68 18.3333 15.2727 18.3333C16.8545 18.3333 17.7491 16.7733 17.3782 15.6033L21.2618 11.7575C22.4291 12.115 24 11.2375 24 9.66667C24 8.475 23.0182 7.5 21.8182 7.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 9.22727L17.2609 7.25136L19.2273 6.36364L17.2609 5.47591L16.3636 3.5L15.4855 5.47591L13.5 6.36364L15.4855 7.25136L16.3636 9.22727Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38636 10.1364L4.86364 8.22728L6.77273 7.75001L4.86364 7.27274L4.38636 5.36365L3.90909 7.27274L2 7.75001L3.90909 8.22728L4.38636 10.1364Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageSolid);
export default __webpack_public_path__ + "static/media/usage-solid.29f15b6be14d4a9ac3060b3a8e168c4d.svg";
export { ForwardRef as ReactComponent };